export const getAdminStatus = (adminCode: '10' | '20' | '30' | '50') => {
  let status = '--';
  switch (adminCode) {
    case '10':
      status = '신청';
      break;
    case '20':
      status = '심사중';
      break;
    case '30':
      status = '반려';
      break;
    case '50':
      status = '정상';
      break;
    default:
      status = '--';
  }

  return status;
};
